import { KeyboardEvent, MouseEvent } from 'react';

/**
 * Elements inside a table row that do their own thing. Clicks in MUI menus
 * and dialogs also bubble to the row through their portals, so those count.
 */
const INTERACTIVE = [
  'a',
  'button',
  'input',
  'select',
  'textarea',
  'label',
  '[role="button"]',
  '[role="checkbox"]',
  '[role="combobox"]',
  '[role="option"]',
  '[role="menuitem"]',
  '[role="dialog"]',
  '[role="presentation"]',
  '.MuiModal-root',
  '.MuiBackdrop-root',
  // The whole selection cell, not only the box: a near miss used to open the
  // row and drop the selection.
  '.MuiTableCell-paddingCheckbox'
].join(',');

/** True when the click should open the row (not a control, not a selection). */
export function isRowOpenClick(event: MouseEvent<HTMLElement>): boolean {
  const target = event.target as HTMLElement | null;
  if (target?.closest(INTERACTIVE)) return false;
  // Selecting text to copy it is not an "open" click.
  const selection = window.getSelection?.();
  if (selection && selection.toString().length > 0) return false;
  return true;
}

/** Row props: open on click (and Enter on the focused row), pointer cursor. */
export function rowOpenProps(open: () => void) {
  return {
    onClick: (event: MouseEvent<HTMLElement>) => {
      if (isRowOpenClick(event)) open();
    },
    tabIndex: 0,
    onKeyDown: (event: KeyboardEvent<HTMLElement>) => {
      // Only the row itself: Enter in a control inside it is the control's.
      if (event.key === 'Enter' && event.target === event.currentTarget) {
        open();
      }
    },
    sx: { cursor: 'pointer' }
  };
}
